export function createCustomFile(blobParts, fileName, options) {
  const blobData = new Blob(blobParts, options);
  const file = new File([blobData], fileName, options);
  file.idAnexo = options.idAnexo;
  return file;
}